import React, { useEffect, useState } from "react";
import CommonFreeTextInput from "../common/inputs/CommonFreeTextInput";
import InvoiceList from "./InvoiceList";
import OrderPagination from "../order/OrderPagination";
import { CreateInvoiceModal } from "../modal/createInvoice/CreateInvoiceModal";
import CommonDropdownInput from "../common/inputs/CommonDropdownInput";
import InvoiceTableStats from "./InvoiceTableStats";
import { URLdecode, URLencode } from "../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";
import OrderPaginationClone from "../order/OrderPaginationClone";
import { useSelector } from "react-redux";
import moment from "moment";
import Button1 from "../form/Button1";
import SelectInput from "../form/SelectInput";
import { MenuItem } from "@mui/material";
import CalendarInput1 from "../form/CalendarInput1";

function InvoiceTable() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = URLdecode();
  const { invoiceMeta } = useSelector((state) => state.invoice);
  const [search, setSearch] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(params?.filter || "All");
  const [timeFilter, setTimeFilter] = useState({
    range: "all",
    date: moment().toString(),
  });

  const filterOptions = [
    "All",
    "Draft",
    "Sent",
    "Paid",
    "Overdue",
    "Cancelled",
    "Voided",
  ];

  const handleExport = () => {};

  return (
    <div className="w-full flex flex-col">
      <CreateInvoiceModal open={createModal} setOpen={setCreateModal} />
      <InvoiceTableStats timeFilter={timeFilter} />
      <div className="w-full justify-between items-center flex">
        <div className="w-full max-w-xl flex gap-3">
          <div className="flex flex-1 max-w-[150px]">
            <CommonDropdownInput
              value={selectedFilter}
              onChange={(val) => {
                setSelectedFilter(val);
                navigate(
                  `${location?.pathname}?${URLencode({
                    ...params,
                    filter: val,
                  })}`,
                  { replace: true }
                );
              }}
              options={filterOptions}
            />
          </div>
          <div className="flex flex-1">
            <CommonFreeTextInput
              placeholder="Search by invoice NO"
              value={search}
              onChange={(val) => setSearch(val)}
            />
          </div>
        </div>
        <div className="flex gap-2 items-center">
          <Button1
            variant="text"
            className="capitalize !w-auto"
            onClick={handleExport}
          >
            Export
          </Button1>
          <div className="flex gap-2 items-center light-bg rounded-md p-2">
            <SelectInput
              defaultValue="Weekly"
              size="small"
              label=""
              value={timeFilter?.range}
              onChange={(ev) =>
                setTimeFilter({ ...timeFilter, range: ev.target.value })
              }
            >
              <MenuItem value="hour">Hourly</MenuItem>
              <MenuItem value="day">Daily</MenuItem>
              <MenuItem value="week">Weekly</MenuItem>
              <MenuItem value="month">Monthly</MenuItem>
              <MenuItem value="year">Yearly</MenuItem>
              <MenuItem value="all">All</MenuItem>
            </SelectInput>
            <CalendarInput1
              value={timeFilter?.date}
              onChange={(obj) =>
                setTimeFilter({ ...timeFilter, date: obj?.start })
              }
            />
          </div>
        </div>
        <div>
          <button
            className="py-3 px-10 rounded-md bg-primary1 text-white cursor-pointer"
            onClick={() => setCreateModal(true)}
          >
            <span className="font-medium  ">Request payment</span>
          </button>
        </div>
      </div>
      <InvoiceList search={search} />
      <div>
        <OrderPaginationClone
          totalCount={invoiceMeta?.total}
          perPage={Number(params?.limit || 10)}
          page={Number(params?.page || 1)}
          callback={(dat) => {
            if (
              Number(params?.page) === dat?.page &&
              Number(params?.limit) === dat?.perPage
            )
              return;
            navigate(
              `${location?.pathname}?${URLencode({
                ...params,
                page: dat?.page,
                limit: dat?.perPage,
              })}`,
              { replace: true }
            );
          }}
        />
      </div>
    </div>
  );
}

export default InvoiceTable;
